import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import styles from "./pharmaSales.module.scss";
import qrcode from "../../../images/qr.png";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getPharmaCollectionSlice } from "../../../store/slices/pharmaSalesSlice";
import { useNavigate } from "react-router-dom";
import { getAllClinic } from "../../../store/slices/clinicSlice";

const PharmaMyCollection = () => {
  const cardRef = useRef(null);
  const navigate = useNavigate();
  const { clinicInfo, allClinicLists } = useSelector((state) => state.clinic);
  const { pharmaSalesCollection } = useSelector((state) => state.pharmaSales);
  const { token } = useSelector((state) => state.auth);
  const currentDate = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    startDate: currentDate,
    endDate: currentDate,
    receivedBy: clinicInfo[0]?.userId?._id,
  });
  const totalAmount = pharmaSalesCollection?.reduce(
    (sum, pharmaSale) => sum + (pharmaSale.afterDiscount || 0),
    0,
  );
  const clinicId =clinicInfo?.[0]?.clinicId || null;
  const dispatch = useDispatch();
  const { state } = useLocation();

  useEffect(() => {
    if (clinicInfo.length > 0 && clinicInfo[0]?.userId?._id) {
      setFormData((prev) => ({
        ...prev,
        receivedBy: clinicInfo[0]?.userId?._id,
      }));
    }
  }, [clinicInfo]);

  useEffect(() => {
    dispatch(
      getAllClinic({
        clinicId,
        loginRole: "ClinicUser",
        token,
      }),
    );
  }, [dispatch, clinicId, token]);
  const handleSelectChange = (selectedOption, name) => {
    if (name === "user") {
      setFormData((prevData) => ({
        ...prevData,
        receivedBy: selectedOption?.value,
      }));
    }
  };
  useEffect(() => {
    if (clinicInfo.length > 0 && formData.receivedBy) {
      dispatch(
        getPharmaCollectionSlice({
          clinicId,
          receivedBy: formData?.receivedBy,
          startDate: formData?.startDate,
          endDate: formData?.endDate,
          token,
        }),
      );
    }
  }, [clinicInfo, dispatch, token]);

  const handleGetData = async () => {
    await dispatch(
      getPharmaCollectionSlice({
        clinicId,
        receivedBy: formData?.receivedBy,
        startDate: formData?.startDate,
        endDate: formData?.endDate,
        token,
      }),
    );
  };
  const generatePDF = () => {
    const card = cardRef.current;

    html2canvas(card, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save("pharma_collection_summary.pdf");
    });
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">Pharma Collection</h4>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/pharmaSales")}
        >
          Back to List
        </button>
      </div>
      <div className="row">
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={formData.startDate}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    startDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={formData.endDate}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    endDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        {clinicInfo[0]?.isAdmin === true && (
          <div className="col-md-3">
            <div className="form-group form-focus focused">
              <label className="focus-label">Received By</label>
              <div className="cal-icon">
                <Select
                  required
                  placeholder="Select User"
                  options={allClinicLists?.map((c) => ({
                    value: c?.userId?._id,
                    label: c?.userId?.name,
                  }))}
                  onChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "user")
                  }
                  // isDisabled={
                  //   clinicInfo[0]?.isAdmin ? false : true
                  // }
                />
              </div>
            </div>
          </div>
        )}
        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleGetData}>
            Get Data
          </button>
        </div>
      </div>
      <div className="container mt-3">
        <div
          className="card p-4 shadow-lg d-flex flex-column"
          ref={cardRef}
          style={{
            color: "#000",
            height: "1623px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div className="text-center mb-3">
            <h3
              className={styles.InvoiceHeading}
              style={{ textDecoration: "underline", color: "#000" }}
            >
              PHARMA COLLECTION SUMMARY
            </h3>
          </div>

          <div
            className="d-flex align-items-start mt-4"
            style={{ color: "#000" }}
          >
            <div>
              <span>Received By</span>
              {/* <br />
              <span>Received Time</span> */}
            </div>
            <div className="mx-4">
              <span>
                <b>{pharmaSalesCollection[0]?.receivedBy?.name || "N/A"}</b>
              </span>
              {/* <br />
              <b>
                {pharmaSalesCollection[0]?.paymentDate
                  ? new Date(
                      pharmaSalesCollection[0]?.paymentDate
                    ).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : "N/A"}
              </b> */}
            </div>
            <div className="ms-auto">
              <span>Received Date:</span>
              <b>
                {pharmaSalesCollection[0]?.paymentDate
                  ? new Date(
                      pharmaSalesCollection[0].paymentDate,
                    ).toLocaleDateString("en-CA")
                  : "N/A"}
              </b>
            </div>
          </div>
          <table
            className="table mt-4 text-center"
            style={{ borderCollapse: "collapse", color: "#000" }}
          >
            <thead
              style={{
                backgroundColor: "#07bc0c",
                color: "#fff",
                height: "40px",
              }}
            >
              <tr>
                <th style={{ padding: "5px" }}>Patient Name</th>
                <th style={{ padding: "5px" }}>Receipt Id</th>
                <th style={{ padding: "5px" }}>Received Date</th>
                <th style={{ padding: "5px" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {pharmaSalesCollection?.length > 0 &&
                pharmaSalesCollection.map((pharmaSale) => (
                  <tr key={pharmaSale?._id}>
                    <td style={{ padding: "5px" }}>
                      {pharmaSale?.patientId?.userId?.name || "N/A"}
                    </td>
                    <td style={{ padding: "5px" }}>
                      {pharmaSale?.billId || "N/A"}
                    </td>
                    <td style={{ padding: "5px" }}>
                      {new Date(pharmaSale.paymentDate).toLocaleDateString(
                        "en-CA",
                      ) || "N/A"}
                    </td>
                    <td style={{ padding: "5px" }}>
                      {pharmaSale?.afterDiscount || "N/A"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <div className="d-flex justify-content-end w-100">
            <span className="fw-bold me-2">Total:</span>
            <span>{totalAmount}</span>
          </div>

          {/* Bottom-Fixed Section */}
          <div
            style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              backgroundColor: "#fff",
              padding: "10px",
            }}
          >
            <div
              className="d-flex justify-content-between mt-4 ms-5 me-5"
              style={{ padding: "10px", fontWeight: "bold" }}
            >
              <span>Billed By: SimpleeKare</span>
              <span>Signature</span>
            </div>
            <div className="row pb-4 ps-5 pe-5">
              <div style={{ backgroundColor: "#40be47", padding: "1px" }}></div>
              <div className="col-sm-12 p-0 mt-4">
                <div className="brand-logo d-flex align-items-center justify-content-between">
                  <img
                    className="logo-abbr me-2"
                    src={qrcode}
                    alt=""
                    style={{ width: "80px" }}
                  />
                  <b style={{ fontSize: "0.85rem" }}>
                    * No Extra Amount to be paid apart from Billing Amount.
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          className="btn btn-primary mt-3 text-white"
          onClick={generatePDF}
        >
          Download PDF
        </button>
      </div>
    </>
  );
};

export default PharmaMyCollection;
